import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getIncentiveTitle } from 'site-modules/shared/utils/incentives';
import { IncentivesEntities } from 'client/data/models/incentives';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

export function IncentivesListPreview({
  incentives,
  className = 'px-1 px-md-1_5 pb-1 pb-md-1_5',
  hasSeparator = true,
  listClasses = 'medium ps-1',
  listItemClasses = null,
}) {
  return (
    <div className={classnames('preview', className)}>
      {hasSeparator && <hr className="mt-0" />}
      <ul className={classnames('preview-list', listClasses)}>
        {incentives.map((incentive, index) => (
          <li key={`preview-${incentive.id}`} className={classnames(listItemClasses, { 'mt-0_5': index })}>
            {incentive.rebateAmount ? formatPriceString(incentive.rebateAmount) : ''} {getIncentiveTitle(incentive)} -
            Expires {incentive.endDate}
          </li>
        ))}
      </ul>
    </div>
  );
}

IncentivesListPreview.propTypes = {
  incentives: IncentivesEntities.SpecificIncentivesGraphql.isRequired,
  className: PropTypes.string,
  listClasses: PropTypes.string,
  listItemClasses: PropTypes.string,
  hasSeparator: PropTypes.bool,
};
